import * as net from 'util/Net';

import {ServerDocumentEditorLock} from './DocumentEditorLockConstants';

export function acquireLock(documentId: string): Promise<ServerDocumentEditorLock | null> {
  return net.postJSONPromise({
    url: `/1/api/document-editor-lock/acquire_lock`,
    data: {documentId},
  });
}

export function acquireLocks(
  documentIds: Array<string>
): Promise<Record<string, ServerDocumentEditorLock> | null> {
  return net.postJSONPromise({
    url: `/1/api/document-editor-lock/acquire_locks`,
    data: {documentIds},
  });
}

export function releaseLock(documentId: string): Promise<ServerDocumentEditorLock | null> {
  return net.postJSONPromise({
    url: `/1/api/document-editor-lock/release_lock`,
    data: {documentId},
  });
}

export function releaseLocks(
  documentIds: Array<string>
): Promise<Record<string, ServerDocumentEditorLock> | null> {
  return net.postJSONPromise({
    url: `/1/api/document-editor-lock/release_locks`,
    data: {documentIds},
  });
}

export function fetchLock(documentId: string): Promise<ServerDocumentEditorLock | null> {
  return net.postJSONPromise({
    url: `/1/api/document-editor-lock/fetch_lock`,
    data: {documentId},
  });
}
